export default __webpack_public_path__ + "static/media/tmp_company.6c1994e5.png";